import React, { useState } from 'react';

import BusinessLoactions from '../../DropdownMenu/BuisnessLocations';

import './index.scss';

const getLabel= function(label,selectedLocation){
  const { brand_ids, studioId } = selectedLocation;
  if(brand_ids && studioId && brand_ids.includes(studioId)){
    return 'All accounts avg';
  }else{
    return label;
  }

}
const filterHiddenLocation= function(locations, hiddenlocation){
  if(hiddenlocation){
  return locations.filter(locaton=>locaton.studioId!==hiddenlocation.studioId);
  }else{
    return locations;
  }
}
const LocationDropDown = ({ info, locations, setSelectedLocation, selectedLocation, locationHidden }) => {
  const [userTypeDropdownVisibility, setVisibility] = useState(false);
  return (
    <div className="business-name">
      {locations && locations.length>1?
      (<div className="drop-down">
        <a
          href="#"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            setVisibility(true);
          }}
        >
          <span className="range-display">{getLabel(selectedLocation.studioName, selectedLocation)}</span>
          {'  '}
          <i className="material-icons">arrow_drop_down</i>
        </a>
        <BusinessLoactions
          visibility={userTypeDropdownVisibility}
          position="tl"
          onVisibilityChange={(visibility) => {
            setVisibility(visibility);
          }}
          className="menu__dropdown location-selection"
          onChange={(event) => {
            setSelectedLocation(event);
          }}
          selectedOption={selectedLocation}
          dropdownMenu={filterHiddenLocation(locations,locationHidden)}
        />
      </div>):(
        <div className="drop-down">
           <span className="range-display">{info.BUSINESS_NAME}</span>
        </div>
      )}
    </div>
  );
};

export default LocationDropDown;
